export default __webpack_public_path__ + "static/slider-general_mobile-dd8f0a71a6544056d7f062aa993ec2d4.jpg";